<template>
  <div class="page container-fluid h-100">
    <div class="row no-gutters row-md-h-100">
      <div class="spec-content col-12">
        <div class="col no-padding" v-html="page.content">{{ page.content }}</div>
        <b-link class="more" :to="{ name: 'Kontakt' }">
          Kontakt
          <font-awesome-icon
            icon="arrow-right"
            :style="{ 'margin-left': '2rem', 'color': '#292a2b' }"
          />
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page",
  data() {
    return {
      image: null,
    };
  },
  computed: {
    page() {
      return this.$store.getters.getPage(this.$route.path);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
  padding: 0;
  margin: 0;
  overflow: hidden;
  min-height: 800px;
}
.spec-content {
  padding: 2rem 3rem;
}
.spec-content h1, h2, h3, h4, h5, h6 {
  font-weight:600;
}

@media (min-width: 960px) {
  .spec-content {
    padding: 4rem 5rem;
  }
}
</style>
<style scoped>
.article {
  padding: 2rem 3rem;
}
@media (min-width: 960px) {
  .article {
    padding: 2rem 5rem;
  }
}
</style>